import { useSelector } from 'react-redux';
import { ICustomMap } from 'types/ICustomMap';
import { ECustomerType } from 'pages/CommandCenter/Accounts/types';

export const useIsIntegratorWorkspace = (): boolean => {
    const customerType = useSelector(({ workspace }: ICustomMap) => workspace?.customer_type);
    return customerType === ECustomerType.integrator;
};

export default useIsIntegratorWorkspace;
